// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { navigationDrawerStyles } from "@tps/Overrides/Components/NavigationDrawer";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

navigationDrawerStyles.drawer = {
    size: 360,
    cssOverrides: {
        drawerContent: css`
            overflow-x: hidden;
        `,
    },
};
navigationDrawerStyles.panelMenu = {
    cssOverrides: {
        wrapper: css`
            > button {
                width: calc(100% - 2px);
            }
        `,
    },
};
navigationDrawerStyles.panelSectionWrapper = {
    css: css`
        display: flex;
        align-items: center;
        width: 100%;
    `,
};
navigationDrawerStyles.menuRowIcon = {
    size: 22,
    css: css`
        margin-top: -2px;
        margin-right: 10px;
        width: 24px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
    `,
};
navigationDrawerStyles.mainNavigationRowTypography = {
    color: "text.main",
    size: 14,
    weight: "bold",
    lineHeight: "22px",
};
navigationDrawerStyles.mainNavigationRowLink = {
    color: "text.main",
    typographyProps: {
        size: 14,
        weight: "bold",
        css: css`
            &&& {
                line-height: 22px;
            }
        `,
    },
    css: css`
        &:hover,
        &:focus,
        &:visited {
            color: ${color("text.main")};
        }
    `,
};
navigationDrawerStyles.logoLinks = {
    color: "common.white",
    typographyProps: {
        color: "text.main",
        ellipsis: true,
        size: 14,
        weight: "bold",
    },
};
navigationDrawerStyles.signOutRow = {
    css: css`
        margin: 0;
    `,
};
navigationDrawerStyles.separator = {
    css: css`
        height: 1px;
        border-top: 1px solid ${color("common.border")};
        margin: 24px auto 8px;
        width: calc(100% - 32px);
    `,
};
navigationDrawerStyles.icon = {
    color: "primary.main",
    size: 16,
    css: css`
        margin-left: 8px;
    `,
};
navigationDrawerStyles.fulfillmentSectionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        row-gap: 4px;
    `,
};
navigationDrawerStyles.fulfillmentMethodValue = {
    size: 14,
    lineHeight: "22px",
    weight: "normal",
};